module.exports = __webpack_public_path__ + "img/help-desk.c74b8131.svg";